import { API_SERVER_URL } from 'config';
import { createRequestUrl } from 'services/utils';

const downloadFile = async (endpoint, filename, token = null) => {
  const headers = {};

  if (token) {
    headers.Authorization = token;
  }

  const response = await fetch(createRequestUrl(API_SERVER_URL, endpoint), {
    headers,
  });

  if (!response.ok) {
    const error = await response.json();
    const message = error.message ?? 'Download failed';
    throw new Error(message);
  }

  const blob = await response.blob();

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export { downloadFile };
